<div class="scrollbox-content">
    <ng-content></ng-content>
</div>